<div class="h-screen flex flex-col bg-gray-50">
    @if (!isLoginPage()) {
        <brd-header (menuToggle)="toggleMobileMenu()"/>
    }

    <div class="flex flex-1 overflow-hidden relative">
        @if (!isLoginPage()) {
            <brd-sidebar
                [mobileMenuOpen]="mobileMenuOpen()"
                (menuClose)="closeMobileMenu()"
            />
        }

        <!-- Main Content -->
        <main class="flex-1 overflow-y-auto">
            <router-outlet/>
        </main>
    </div>
</div>
